import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('book_of_dead', {
  cherry: 'papyrus_scroll',
  lemon: 'inkpot_pen',
  orange: 'scarab_seal',
  bell: 'maat_feather',
  star: 'thoth_wild',
  seven: 'spell_tablet',
  gem: 'amulet_gem',
  scatter: 'book_of_dead_scatter',
  money: 'golden_offering',
});

/** Book of the Dead — GENERATED by scaffoldSlot from
 *  content/slots/book_of_dead.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const BOOK_OF_DEAD_THEME: Theme = {
  id: 'book_of_dead',
  name: 'Book of the Dead',
  palette: {
    accent: 0x3e9e72,
    secondary: 0xe0a52e,
    warm: 0xffe09a,
    frameFill: 0x10241a,
    bgGradientTop: 0x12281d,
    bgGradientBottom: 0x060d09,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Papyrus', glyph: '📜', tint: 0xD8C48A, weight: 5, textureAlias: 'book_of_dead:cherry',
        winVideoAlias: 'book_of_dead:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Scribe\'s Ink', glyph: '🖋️', tint: 0x3E9E72, weight: 5, textureAlias: 'book_of_dead:lemon',
        winVideoAlias: 'book_of_dead:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Scarab Seal', glyph: '🪲', tint: 0xE0A52E, weight: 4, textureAlias: 'book_of_dead:orange',
        winVideoAlias: 'book_of_dead:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Maat Feather', glyph: '🪶', tint: 0xFFE09A, weight: 3, textureAlias: 'book_of_dead:bell',
        winVideoAlias: 'book_of_dead:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Thoth', glyph: '🐦', tint: 0xFFE49A, weight: 2, textureAlias: 'book_of_dead:star',
        winVideoAlias: 'book_of_dead:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Spell Tablet', glyph: '🔯', tint: 0x3E9E72, weight: 2, textureAlias: 'book_of_dead:seven',
        winVideoAlias: 'book_of_dead:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Amulet Gem', glyph: '💎', tint: 0x3E9E72, weight: 2.5, textureAlias: 'book_of_dead:gem',
        winVideoAlias: 'book_of_dead:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Book of the Dead', glyph: '📖', tint: 0x3e9e72, weight: 0.5, textureAlias: 'book_of_dead:scatter',
        winVideoAlias: 'book_of_dead:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Golden Offering', glyph: '🪙', tint: 0xe0a52e, weight: 1, textureAlias: 'book_of_dead:money',
        winVideoAlias: 'book_of_dead:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x10241a, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x3e9e72, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffe09a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x10241a, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe0a52e, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x3e9e72, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffe09a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x10241a, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffe09a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x3e9e72, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffe09a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xffe09a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'book_of_dead:bg', path: 'environment/book_of_dead.png' },
      columnBackground: { alias: 'book_of_dead:column_bg', path: 'reel/book_of_dead_column_bg.png' },
      border: { alias: 'book_of_dead:border', path: 'brand/border_egypt.png' },
    },
  },
};
